import mod from "-!../../../../node_modules/cache-loader/dist/cjs.js!../../../../node_modules/babel-loader/lib/index.js??ref--2-1!../../../../node_modules/vue-loader/lib/index.js??vue-loader-options!../../../../node_modules/import-glob/index.js!./MenuItem.vue?vue&type=script&lang=js"; export default mod; export * from "-!../../../../node_modules/cache-loader/dist/cjs.js!../../../../node_modules/babel-loader/lib/index.js??ref--2-1!../../../../node_modules/vue-loader/lib/index.js??vue-loader-options!../../../../node_modules/import-glob/index.js!./MenuItem.vue?vue&type=script&lang=js"


//////////////////
// WEBPACK FOOTER
// ./scripts/vue/MenuItem.vue?vue&type=script&lang=js
// module id = 13
// module chunks = 0